export default "__VITE_ASSET__B8BSoCr9__"